import { useState } from 'react';
import { Eye, EyeSlash } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';
import pt from '../../locales/pt';

/**
 * Password field with show/hide toggle.
 */
export function PasswordInput({ className, id, invalid = false, ...props }) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        aria-invalid={invalid || undefined}
        data-ds-id="ds/input/text--default"
        className={cn(
          'flex w-full rounded-ds-md bg-card border border-border px-space-4 py-space-3 pr-space-8 text-type-body font-body text-foreground placeholder:text-stone-400 focus:border-sage-500 focus:ring-4 focus:ring-sage-glow-soft focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
          invalid && 'border-danger-500',
          className,
        )}
        {...props}
      />
      <button
        type="button"
        className="absolute right-space-3 top-1/2 -translate-y-1/2 rounded p-1 text-stone-500 hover:text-foreground"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? pt.auth.fields.hidePassword : pt.auth.fields.showPassword}
        tabIndex={-1}
      >
        {visible ? <EyeSlash className="h-4 w-4" aria-hidden /> : <Eye className="h-4 w-4" aria-hidden />}
      </button>
    </div>
  );
}
